<template>
  <el-dialog
    v-loading="loading"
    class="feedback-resp-modal"
    width="90%"
    title="反馈答复信息"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div style="word-break: break-all; font-weight: bold;">
      {{ answer }}
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
export default {
  name: 'FeedbackRespModal',
  mixins: [ModalMixin],
  data () {
    return {
      answer: ''
    }
  },
  methods: {
    init (answer) {
      this.answer = answer
      return this.open()
    }
  }
}
</script>
<style lang="stylus">
.feedback-resp-modal
  .el-dialog
    max-width 480px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
</style>
